import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

import "./SelectFormControlComponent.css";

const SelectFormControl = ({ options, onChange, value, placeholder, name, maxhight }) => {

  const customStyles = {
    control: (base) => ({
      ...base,
      //backgroundColor: "#0f172a",
      borderColor: "#334155",
      minHeight: "40px",
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),

    menu: (base) => ({
      ...base,
      // backgroundColor: "#1e293b",
      zIndex: 9999,
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "grey" : "white",
      color: "var(--text-primary)",
    }),

    singleValue: (base) => ({
      ...base,
       color: "var(--text-primary)",
    }),

    placeholder: (base) => ({
      ...base,
      color: "#94a3b8",
    })
  };


  return (
    <Select
    className="basic-single"
    classNamePrefix={name}
    placeholder={placeholder}
    isClearable={false}
    value={value}
    isSearchable={true}
    name={name}
    options={options}
    maxMenuHeight={maxhight}
    onChange={(e) => onChange(name,e)}
    menuPortalTarget={document.body}
    styles={customStyles}
    />
  );
};


SelectFormControl.propTypes = {
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
};

SelectFormControl.defaultProps = {
  value: null
};

export default SelectFormControl;